import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button } from '@common/components/Button';
import { FormControl } from '@common/components/form-control';
import { I18n } from 'react-redux-i18n';
import cx from 'classnames';

import '../styles/AmbryIDs.scss';

export default class AmbryIDsTable extends Component {
    static propTypes = {
        name: PropTypes.string,
        ambryIDs: PropTypes.array,
        changeOrgName: PropTypes.func,
        updateAmbryID: PropTypes.func,
        changeClientID: PropTypes.func,
        addAmbryID: PropTypes.func,
        removeAmbryID: PropTypes.func,
    };

    onOrgNameChange = (e) => {
        const targetId = e.target.id;
        const id = targetId === "Orgname_-1" ? -1 : targetId.substring(targetId.lastIndexOf('_') + 1);
        this.props.changeOrgName(this.props.name, id, e.target.value)
    }

    onOrgNameBlur = (e) => {
        const targetId = e.target.id;
        const id = targetId === "Orgname_-1" ? -1 : targetId.substring(targetId.lastIndexOf('_') + 1);
        this.props.updateAmbryID(this.props.name, id)
    }

    onClientIDChange = (e) => {
        const targetId = e.target.id;
        const id = targetId === "ClientId_-1" ? -1 : targetId.substring(targetId.lastIndexOf('_') + 1);
        this.props.changeClientID(this.props.name, id, e.target.value)
    }

    onClientIDBlur = (e) => {
        const targetId = e.target.id;
        const id = targetId === "ClientId_-1" ? -1 : targetId.substring(targetId.lastIndexOf('_') + 1);
        this.props.updateAmbryID(this.props.name, id, e.target.value)
    }

    onAddIdClicked = (e) => {
        this.props.addAmbryID()
    }

    onRemoveIdClicked = (e) => {
        const targetId = e.target.id;
        const id = e.target.id === -1 ? -1 : targetId.substring(targetId.lastIndexOf('_') + 1);
        this.props.removeAmbryID(id)
    }

    get inputs() {
        return this.props.ambryIDs.map((ambryId, index) => (
            <div key={index} className="User-details-settings-ambry-ids__inputs__item">
                <FormControl
                    id={'Orgname_' + ambryId.profileId}
                    className="form-control"
                    type="text"
                    placeholder={I18n.t('Organization Name')}
                    value={ambryId.organizationName || ''}
                    tabIndex="5"
                    onChange={this.onOrgNameChange}
                    onBlur={this.onOrgNameBlur}
                />
                <FormControl
                    id={'ClientId_' + ambryId.profileId}
                    className="form-control"
                    type="text"
                    placeholder={I18n.t('Clinician ID')}
                    value={ambryId.clientID || ''}
                    tabIndex="6"
                    onChange={this.onClientIDChange}
                    onBlur={this.onClientIDBlur}
                />
                <i id={'Remove_' + ambryId.profileId} className="fa fa-remove" onClick={this.onRemoveIdClicked}/>
            </div>
        ))
    }

    render() {
        const { className } = this.props;

        return (
            <div className={cx("User-details-settings-ambry-ids", className)}>
                <div className="User-details-settings-ambry-ids__inputs">
                    {this.inputs}
                </div>
                <div className="User-details-settings-ambry-ids__controls">
                    {this.props.name && (
                        <Button 
                            type="submit"
                            tabIndex="7" 
                            onClick={this.onAddIdClicked}
                        >
                            {I18n.t('Add ID')}
                        </Button>
                    )}
                </div>
            </div>
        );
    }
}